import React from 'react';
export interface IconProps {
  color?: string;
  width?: number;
  height?: number;
}
const WSIconEmail = ({ color = '#00B4D8', width = 24, height = 24 }: IconProps) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width={width} height={height} rx="4" fill="#0077B6" />
    <path
      d="M16.6666 6.66667H7.33331C6.80288 6.66667 6.29417 6.87738 5.9191 7.25245C5.54403 7.62753 5.33331 8.13623 5.33331 8.66667V15.3333C5.33331 15.8638 5.54403 16.3725 5.9191 16.7475C6.29417 17.1226 6.80288 17.3333 7.33331 17.3333H16.6666C17.1971 17.3333 17.7058 17.1226 18.0809 16.7475C18.4559 16.3725 18.6666 15.8638 18.6666 15.3333V8.66667C18.6666 8.13623 18.4559 7.62753 18.0809 7.25245C17.7058 6.87738 17.1971 6.66667 16.6666 6.66667ZM7.33331 8H16.6666C16.8435 8 17.013 8.07024 17.1381 8.19526C17.2631 8.32029 17.3333 8.48986 17.3333 8.66667L12 11.92L6.66665 8.66667C6.66665 8.48986 6.73688 8.32029 6.86191 8.19526C6.98693 8.07024 7.1565 8 7.33331 8ZM17.3333 15.3333C17.3333 15.5101 17.2631 15.6797 17.1381 15.8047C17.013 15.9298 16.8435 16 16.6666 16H7.33331C7.1565 16 6.98693 15.9298 6.86191 15.8047C6.73688 15.6797 6.66665 15.5101 6.66665 15.3333V10.1867L11.6533 13.2333C11.7547 13.2918 11.8696 13.3227 11.9866 13.3227C12.1037 13.3227 12.2186 13.2918 12.32 13.2333L17.3333 10.1867V15.3333Z"
      fill="white"
    />
    <rect x="5" y="6" width="14" height="12" rx="2" fill="#90E0EF" />
    <path
      d="M5 8C5 6.89543 5.89543 6 7 6H17C18.1046 6 19 6.89543 19 8V8.88197C19 9.26074 18.786 9.607 18.4472 9.77639L12.8944 12.5528C12.3314 12.8343 11.6686 12.8343 11.1056 12.5528L5.55279 9.77639C5.214 9.607 5 9.26074 5 8.88197V8Z"
      fill={color}
    />
  </svg>
);
export default WSIconEmail;
